var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white p-4 lg:p-6 min-h-full shadow-xl rounded-xl"})
}
var staticRenderFns = []

export { render, staticRenderFns }